export default __webpack_public_path__ + "static/media/greenUnfilledDot.204260cb.svg";